import { Component, computed } from 'vue';
import { IRouter, Routes, TRoutes } from '@/models/router/router.interface';

import ImportFile from '@/presentation/pages/import-file/import-file.vue';
import Overview from '@/presentation/pages/overview/overview.vue';
import ErrorDetails from '@/presentation/pages/error-details/error-details.vue';

import InitialRoutePresenter from '@/presenters/initial-route-presenter';

import store from '@/store';

export default class AppCode {
	private routes: TRoutes = {
		[Routes.IMPORT_FILE]: ImportFile,
		[Routes.OVERVIEW]: Overview,
		[Routes.ERROR_DETAILS]: ErrorDetails
	};

	public errorMessage = computed((): string => {
		return store.getters.errorMessage();
	});

	// eslint-disable-next-line @typescript-eslint/naming-convention
	public CurrentComponent = computed((): Component => {
		return this.routes[this.router.value.current];
	});

	public router = computed((): IRouter => {
		return store.getters.router();
	});

	public mounted(): void {
		InitialRoutePresenter.prepareForRoutingActions();
	}
}
